<template>
  <v-layout class="form-group">
    <slot />
  </v-layout>
</template>

<script>
export default {
  name: 'FormGroup',
}
</script>

<style scoped>
.form-group {
  font-size: 16px;
  margin-bottom: 20px;
  flex-direction: column;
}
</style>
